// @flow
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import _ from 'lodash';
import DropDownMenu from 'common/components/DropDownMenu';
import SearchBar from 'common/components/SearchBar';
import Card from 'common/components/Card';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

const FieldWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.metrics.smallMargin}px;
`;

type Props = {
  options: Object;
  onOptionsChange: (options: Object) => void;
  orderByItems: Array<{ label: string, value?: Object }>,
  theme: any,
  filterComponent: Node,
  children: Node,
  extraElementRight?: Component<any, any>
};

type State = {
  query: string,
};

class FilterTableHeader extends Component<Props, State> {
  delayedOnSearch: (value: string) => void;

  constructor(props: Props) {
    super(props);

    this.state = {
      query: props.options.searchText || '',
    };

    this.delayedOnSearch = _.debounce((value: string) => this.onSearch(value), 400);
  }

  onSearch = (value: string) => {
    this.props.onOptionsChange({ ...this.props.options, searchText: value });
  };

  onSortBy = (value: Object) => {
    this.props.onOptionsChange({ ...this.props.options, sortBy: value });
  };

  onFilterBy = (value: any) => {
    this.props.onOptionsChange({ ...this.props.options, filterBy: value });
  };

  render() {
    const { theme, options, filterComponent, extraElementRight } = this.props;
    const hasFilterComponent = Boolean(filterComponent);

    return (
      <Container className="row">
        <div
          style={{ margin: 0, padding: 0 }}
          className={`row col-md-${extraElementRight ? 6 : 8} col-sm-12 col-xs-12`}
        >
          <FieldWrapper className={`col-md-6 col-sm-${hasFilterComponent ? 6 : 12} col-xs-12`}>
            <DropDownMenu
              items={this.props.orderByItems}
              onChange={this.onSortBy}
              textColor={theme.colors.primaryText}
              selectedTextColor={theme.colors.primary}
              value={this.props.options.sortBy}
            />
          </FieldWrapper>
          {hasFilterComponent &&
            <FieldWrapper className="col-md-6 col-sm-6 col-xs-12">
              <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {
                  React.Children.map(this.props.filterComponent, (filter) => {
                    return React.cloneElement(filter, {
                      onFiltersChange: this.onFilterBy,
                      selectedFilters: options.filterBy,
                    });
                  })
                }
              </Card>
            </FieldWrapper>
          }
        </div>
        <div
          style={{ margin: 0, padding: 0 }}
          className={`row col-md-${extraElementRight ? 6 : 4} col-sm-12 col-xs-12`}
        >
          <FieldWrapper className={`col-md-${extraElementRight ? 6 : 12}
                                    col-sm-${extraElementRight ? 6 : 12}
                                    col-xs-12`}
          >
            <SearchBar
              onChange={(value: string) => {
                this.delayedOnSearch(value);
                this.setState({ query: value });
              }}
              value={this.state.query}
            />
          </FieldWrapper>
          {extraElementRight &&
          <FieldWrapper className={'col-md-6 col-sm-6 col-xs-12'}>
            {extraElementRight}
          </FieldWrapper>
        }
        </div>
      </Container>
    );
  }
}


export default withTheme(FilterTableHeader);



// WEBPACK FOOTER //
// ./src/common/components/FilterTableHeader.js